export const ADD_COMMENTS_DATA = 'ADD_COMMENTS_DATA';
export const GET_COMMENTS = 'GET_COMMENTS';
export const UPDATE_POPUP_KEYS = 'UPDATE_POPUP_KEYS';
export const ADD_COMMENT = 'ADD_COMMENT';
export const UPDATE_COMMENT_DATA = 'UPDATE_COMMENT_DATA';
export const DELETE_COMMENT_DATA = 'DELETE_COMMENT_DATA';
export const CHANGE_COMMENT_COUNT = 'CHANGE_COMMENT_COUNT';
